// extracted by mini-css-extract-plugin
module.exports = {"content":"screen-select_content_uLRT6"};